import React, { useEffect, useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, Badge, CardGroup, Nav, Button, Form, Spinner, Alert } from 'react-bootstrap';
import { Translate } from '@styled-icons/heroicons-outline/Translate';
import { Profile } from '@styled-icons/icomoon/Profile';
import { Googlechat } from '@styled-icons/simple-icons/Googlechat';

import { enviafaleconosco } from '../../actions/eventos/eventos';

//Utils
import { 
    getEvento, getLinguagemCred,
    setLinguagemCred, getCategoriaCredDescricao, 
    getUserLoginCred } from '../../utils/eventosessioncred';
import { getTraducaoTrocaPor as trad } from '../../utils/getTraducoes';
import { UseWindowDimensions } from '../../utils/getSizeScreen';
import { ListenProdutosPedidosConfirmados, validaCarrinho } from '../../utils/produtosCalculos';
import { TelaModalLivre } from '../../helpers/TelaModal';
import { campotexto, campotextarea } from '../../components/forms/campos/campos';

const Header = ({history, getLinguagem, prelogin, pagina, trads, enviafaleconosco, pendingTasks, products }) => {
    
    const descricaocred = getCategoriaCredDescricao();
    const usuario = getUserLoginCred();
    
    const [idiomas_evento, setIdiomas] = useState([]);
    const [linguagem, setLinguagem] = useState(getLinguagemCred()!==null?getLinguagemCred():'pt');
    const [evento, setEvento] = useState({});
    const [imagemevento, setImagemEvento] =  useState(null);
    const [showChat, setShowChat] =  useState(false);
    const [showChatEnviado, setShowChatEnviado] =  useState(null);
    const [carrinho_valido, setCarrinhoValido] =  useState(null);
    const screen = UseWindowDimensions();
    
    useEffect(() => {
        if(evento.idevento && evento.imagens[0] && evento.imagens[0].imagem){
            if(screen.width<800){
                const result = evento.imagens.filter(img => {
                    return img.campo === 'imagemeventomobile';
                });
                setImagemEvento(result[0]?result[0].imagem:'');
            }else{
                setImagemEvento(evento.imagens.filter(img => {
                    return img.campo === 'imagemevento';
                })[0].imagem);
            }
        }
    },[evento, screen]);

    const handleTelaChat = () => {
        setShowChat(showChat===true?false:true);
        if(showChatEnviado!==null){
            setShowChatEnviado(null);
        }
    }

    const handlePdf = (tipo) => {
        const pdfs = [
            {link: 'Passo_a_passo_para quem_ja_se_credenciou_e_esta_escolhendo_um_novo_turno.pdf'},
            {link: 'Passo_a_passo_para_quem_esta_se_credenciando_pela_primeira_vez.pdf'},
            {link: 'Passo_a_passo_para_resetar_a_senha.pdf'},
        ];
        window.open('https://regtronweb.com.br/pdf/render.php?file='+pdfs[tipo].link, '_blank');
    }

    const handleSubmitFaleConosco = async (form) => {
        const response = await enviafaleconosco(form);
        setShowChatEnviado(response.result)        
    }

    const handleDadosFormFaleConosco = () => {
        if(usuario&&usuario.idusuario){
            return {
                nome: usuario.nome+' '+usuario.sobrenome,
                email: usuario.email,
                cpf: usuario.fisica.cpf,
                celular: usuario.fisica.dddcelular+' '+usuario.fisica.celular,
                evento: evento.portugues,
                urlorigem: window.location.href
            }
        }else{
            return {                            
                evento: evento.portugues,
                urlorigem: window.location.href
            }
        }
    }

    const handleVoltaEscolherProduto = () => {
        setCarrinhoValido(null);
        history.push('produtos');        
    }

    const handleValidaCarrinho = () => {
        const check = validaCarrinho();
        const str = history.location.pathname.split("/");        
        if(check.valido===false){
            if(str[str.length-1]!=='produtos'&&str[str.length-1]!=='login'&&str[str.length-1]!=='credencial'){
                setCarrinhoValido(false);
            }
        }
    }
                
    useEffect(() => {
        if(setLinguagemCred !== null){
            setLinguagemCred(linguagem);            
        }

        if(getLinguagem !== null){
            getLinguagem(linguagem);
        }        
    },[linguagem]);

    useEffect(() => {
        setEvento(getEvento());
        setIdiomas(getEvento().idiomavalido&&getEvento().idiomavalido!==null?getEvento().idiomavalido.split("|"):[]);
        
        if(getLinguagemCred()==='null'){
            setLinguagemCred('pt');
            setLinguagem('pt');
        }    

        if(products&&products.length){
            handleValidaCarrinho();
        }

    },[]);

    useEffect(() => {

        if(products&&products.length){
            handleValidaCarrinho();
        }
    },[usuario, pendingTasks]);
    
    return (
        <Card.Header className="text-center border-0" style={{
            zIndex: 100,
            position: 'sticky',
            top: 0,
            overflow: "hidden",
            backgroundColor: "#f7f7f7",           
        }}>
            {carrinho_valido===false?
                <Alert variant="danger">
                    ATENÇÃO: Nenhum dia/turno foi escolhido, <strong style={{cursor: 'pointer'}} onClick={() => handleVoltaEscolherProduto()}> click aqui para escolher!</strong>
                </Alert>
                :
                null
            }
            {pendingTasks ?
                <div style={{height: "10px"}} className="d-flex flex-row-reverse"><Spinner animation="border" /></div>
                :
                <div style={{height: "10px"}}></div>
            }
            <TelaModalLivre btoFechar='Sair' handleCloseModal={handleTelaChat} show={showChat} titulo='Fale Conosco'>
                {showChatEnviado!=null?                
                    showChatEnviado===true?
                    <Alert variant="success">
                        Mensagem enviada com sucesso!
                    </Alert>
                    :
                    <Alert variant="danger">
                        Houve um problema com o envio
                    </Alert>
                :
                <FinalForm                
                onSubmit={handleSubmitFaleConosco}
                initialValues={handleDadosFormFaleConosco()}
                validate={(form) => {
                    const errors = {};
                    if(!form.nome){
                        errors.nome = 'Obrigatório';
                    }

                    if(!form.email){
                        errors.email = 'Obrigatório';
                    }

                    if(!form.comentario){
                        errors.comentario = 'Obrigatório';
                    }
                    return errors;
                }}
                render={({form, submitting, pristine, handleSubmit}) => {

                    return(
                    <form onSubmit={handleSubmit} name='formfaleconosco'>
                        <Form.Group className="mb-3" controlId="email">
                            <Form.Label>Seu Nome</Form.Label>
                            <Field type="text" name="nome" component={campotexto} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="email">
                            <Form.Label>Seu e-mail</Form.Label>
                            <Field type="email" placeholder="nome@exemplo.com" name="email" component={campotexto} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="comentario">
                            <Form.Label>Comentário</Form.Label>
                            <Field type="textarea" rows={3} name="comentario" component={campotextarea} />
                        </Form.Group>
                        <Button type="submit" block disabled={submitting || pristine}>
                            {submitting?<Spinner animation="border" />:'Enviar'}
                        </Button>
                    </form>
                    )
                }}
                />
                }
            </TelaModalLivre>
            <ListenProdutosPedidosConfirmados history={history} trads={trads}  lingua={linguagem} />
            <Card.Img src={imagemevento} variant="center" className="mb-1 text-center" />            
                <CardGroup className="mb-1">
                    <Card className="text-left border-0" style={{ display: "block"}}>
                        {!Object.keys(usuario).length?
                        <>
                        <Translate style={{height: "25px", width: "25px"}} /><small className="font-weight-bold">{trad(trads,'ESCOLHJELING',linguagem)}</small>
                        {idiomas_evento.map(itens => {
                            return (
                                <Badge key={itens} variant="secondary" 
                                onClick={() => setLinguagem(itens)} 
                                style={{cursor: "pointer", opacity: linguagem===itens?'1.0':'0.3'}}>
                                    {itens.toUpperCase()}
                                </Badge>
                            );
                        })}                        
                        </>
                        :
                        null
                        }
                    </Card>                    
                    {prelogin===false?
                    <Card className="text-right border-0" style={{display: "block"}}>                        
                        <Profile size="20" />
                        <Badge className="text-uppercase">
                            {descricaocred[`descricao_${linguagem}`]}
                        </Badge>                        
                    </Card>
                    :
                    null
                    }                    
                </CardGroup>   
                {prelogin===false?
                <Nav fill variant="tabs" className="border-0">
                    <Nav.Item >
                        <Nav.Link className="border-0" active={pagina==='login'?true:false} eventKey="disabled" disabled>{trad(trads,'NAVLOGIN',linguagem)}</Nav.Link>
                    </Nav.Item>
                    
                    <Nav.Item>
                        <Nav.Link className="border-0" active={pagina==='cadastro'?true:false} eventKey="disabled" disabled>{trad(trads,'NAVACAD',linguagem)}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className="border-0" active={pagina==='credencial'?true:false} eventKey="disabled" disabled>{trad(trads,'NAVCRED',linguagem)}</Nav.Link>
                    </Nav.Item>                
                </Nav>  
                :
                null
                }                
        </Card.Header>
    )
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        trads: state.reducerTraducoes,
        products: state.reducerPesquisaSubitem
    }
}

export default connect(mapStateToProps, {enviafaleconosco})(withRouter(Header));